import { ASSET_CATEGORIES_FOR_GAME_ASSETS } from './Asset';

export const SPECIAL_GAME_NAME = 'Creative R&D';

export const CONCLUDED_GAME_LEVEL = 'CONCLUDED';

export const GENERAL_GAME_FOLDERS_NAMES = ASSET_CATEGORIES_FOR_GAME_ASSETS;
